import React from 'react';
import { Col, Row } from 'reactstrap';
import { FormFieldHeader } from '../../../../../components/FormFieldHeader';
import { Control, Controller } from 'react-hook-form';
import { SinglePaginatedSelect } from '../../../../../components/Select/SinglePaginatedSelect';
import { SelectOption } from '../../../../../components/Select';
import { UserService } from '../../../../../services/v1/UserService';
import { DeactivateUserFormValues } from '..';

interface PropTypes {
  control: Control<DeactivateUserFormValues>;
  scheduledInterviewsCount: number;
  interviewTemplatesCount: number;
  currentUserId: number;
}

interface AdditionalType {
  page: number;
}

const defaultAdditional: AdditionalType = {
  page: 1,
};

function UserSelect(props: {
  selected: SelectOption;
  disabled: boolean;
  currentUserId: number;
  onChange: (opt: SelectOption) => void;
}) {
  const loadOptions = async (
    search: string,
    _loadedOptions: unknown,
    { page }: AdditionalType,
  ) => {
    const result = await UserService.list({
      page: page,
      name: search,
      includeOnlyUsersWithConnectedCalendar: true,
    });

    return {
      options: result.users
        .filter((user) => user.id !== props.currentUserId)
        .map(
          (user) =>
            ({
              label: user.name,
              value: user.id.toString(),
            } as SelectOption),
        ),
      hasMore: !!result.nextPage,
      additional: {
        page: page + 1,
      },
    };
  };

  return (
    <SinglePaginatedSelect
      additional={defaultAdditional}
      isClearable={true}
      value={props.selected}
      loadOptions={loadOptions}
      onChange={props.onChange}
      debounceTimeout={300}
      placeholder='Assign a team member to take their place'
      closeMenuOnSelect={true}
    />
  );
}

export function NewAssigneeRow(props: PropTypes) {
  if (props.scheduledInterviewsCount == 0 && props.interviewTemplatesCount == 0)
    return;

  return (
    <div className='item my-4'>
      <Row className='mb-3 align-items-end'>
        <Col sm={12}>
          <div className='d-flex gap-2'>
            <FormFieldHeader fieldName={'New Assignee'} isRequired={true} />
          </div>
          <Controller
            name='user'
            control={props.control}
            rules={{ required: 'User is required' }}
            render={({ field }) => (
              <UserSelect
                selected={field.value}
                onChange={field.onChange}
                disabled={false}
                currentUserId={props.currentUserId}
              />
            )}
          />
        </Col>
      </Row>
    </div>
  );
}
